/** @format */

import React, { useEffect, useState } from 'react';
import { Button, Grid } from '@mui/material';
import { SnackbarFp, PageContainer, StepperKeeper, ButtonLoading } from 'components';
import { useForm, FormProvider } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { useBusiness } from 'hooks';
import isEqual from 'lodash/isEqual';
import { serviceCallAddApi, serviceCallEditApi } from '../services/WebServiceServices';
import { BaseInfo, BodyParameters, Advanced } from './components';
import generateEdit from './components/generateEdit';
import fieldsInTabs from './components/fieldsInTabs';
import { useStyles } from './Style';
import createToast from 'components/Toast/Toast';
import { getDynamicObjectAction , constBreadCrumbsTitle  } from 'utility';


const DefineWebService2 = () => {
  const classes = useStyles();

  const defaultValues = {
    scType: 'REST',
    currentVersion: 1,
    scHttpStatusCode: 200,
    scAutoApprove: 'true',
  };
  const actionsList =
    getDynamicObjectAction([
      'newWebServiceDefinePage',
      'cancelNewWebServiceDefineBtn',
      'editMyWebServiceListBtn',
    ])
  const navigate = useNavigate();
  const { id } = useParams();
  const [loadingPage, setLoadingPage] = useState(true);
  const myBusinessInfo = useBusiness();
  const methods = useForm({ mode: 'onChange', defaultValues });
  const { handleSubmit, reset, trigger } = methods;
  const [selected, setSelected] = useState({});
  const [loading, setLoading] = useState(false);
  const [dataBody, setDataBody] = useState([]);
  const [openSnack, setOpenSnack] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);

  const [originalData, setOriginalData] = useState({});

  const onChangeTab = (index) => {
    setTabIndex(index);
  };

  const selectChange = (name, e) => {
    setSelected((prevState) => {
      return { ...prevState, [name]: e.target.value };
    });
  };

  const checkNextStepAllowed = async (tabIndex) => {
    if (tabIndex === 0) {
      try {
        return await trigger(fieldsInTabs[`tab${tabIndex}`]);
      } catch (error) { }
    }
    return await true;
  };

  const bodyChange = (data) => {
    setDataBody(data);
  };

  const onSubmit = (data) => {
    let increaseVersion = false;
    // When the page is in edit mode
    if (id) {
      // چک کردن نیاز به تغییر ورژن سرویس
      if (data.currentVersion === originalData.currentVersion) {
        const objCheckVersion = {
          scHttpVerb: data.scHttpVerb,
          scUrl: data.scUrl,
          price: data.price,
          scPriceCalculationType: data.scPriceCalculationType,
          scAutoApprove: data.scAutoApprove === 'true',
        };

        if (!isEqual(objCheckVersion, originalData.checkVersion)) {
          alert(
            'با تغییر هر یک از پارامترهای متد، محاسبه، دسترسی، قیمت و آدرس وب سرویس نیاز به تغییر ورژن می باشد.',
          );
          return;
        }
      } else {
        increaseVersion = true;
      }
    }

    let dataHeader = [];

    if (data?.scHeaderParams) {
      dataHeader = data.scHeaderParams.map((item) => {
        let addition = {};
        if (item.typeOfInput === 'optional') {
          addition = { scIsRequired: 'false', scHiddenParameter: 'false' };
        } else if (item.typeOfBody === 'required') {
          addition = { scIsRequired: 'true', scHiddenParameter: 'false' };
        } else if (item.typeOfBody === 'hidden') {
          addition = { scIsRequired: 'false', scHiddenParameter: 'true' };
        }
        const res = { ...item, ...addition };
        delete res.typeOfInput;
        return res;
      });
    }

    const metaDataObj = {
      scGuildCode: typeof data.scGuildCode === 'object' ? data.scGuildCode.code : data.scGuildCode,
      scNamespace: data.scNamespace ? data.scNamespace : null, // *  فضای نام در این بخش وارد میشود که معمولا همان اکشن میباشد
      scUrl: data.scUrl, // *
      scMethodName: data.scMethodName ? data.scMethodName : null, // soap method
      scInputParams: dataBody.length > 0 ? dataBody : null, // body
      scHeaderParams: dataHeader,
      scType: data.scType,
      scEnName: data.scEnName,
      scProvider: data.scProvider,
      scFaName: data.scFaName,
      scHttpVerb: data.scHttpVerb,
      scPriceCalculationType: data.scPriceCalculationType,
      scPriceHeader: data.scPriceHeader ? data.scPriceHeader : '',
      scPriceInquiryUrl: data?.scPriceInquiryUrl ? data.scPriceInquiryUrl : '',
      scInquiryHttpVerb: data?.scInquiryHttpVerb ? data.scInquiryHttpVerb : '',
      scPaymentType: 'SUBSCRIPTIONPLAN', // data.scPaymentType
      scStakeholderList: data.scStakeholderList || [],
      // scFinalPath: data.ScFinalPath, // ادرس دلخواه برای نمایش و فراخوانی سرویس
      scAutoApprove: false,
      scClientId: '',
      scSuccessfulResult: {
        scHttpStatusCode: data.scHttpStatusCode || '',
        scHttpResponse: data.scHttpResponse || '',
      },
      scSendVoucherSMS: data.scSendVoucherSMS,
      scSendApiKey: data.scSendApiKey,
      scIsCallback: data.scIsCallback,
      timeout: data.timeout,
    };

    if (data.scAutoApprove === 'true') {
      metaDataObj.scClientId =
        typeof data.scClientId === 'object' ? data.scClientId.client_id : data.scClientId;
      metaDataObj.scAutoApprove = true;
    }

    if (data.scStakeholderList) {
      let sumPercentage = 0;
      let myBusinessIdExist = false;

      metaDataObj.scStakeholderList = data.scStakeholderList.map((item) => {
        if (item.percentage) {
          sumPercentage += +item.percentage;
          myBusinessIdExist = item.businessId.id === myBusinessInfo.id || myBusinessIdExist;
        }
        if (item.businessId.id !== myBusinessInfo.id) {
          return {
            ...item,
            businessId: item.businessId.id,
          };
        }
      });


    }

    if (data.contentType) {
      metaDataObj.scHeaderParams.push({
        scParameterName: 'content-type',
        scParameterDesc: '',
        scParameterDefaultValue:
          typeof data.contentType === 'object' ? data.contentType.value : data.contentType,
        scIsRequired: 'false',
        scHiddenParameter: 'true',
        scParameterLogMode: 'LOGGABLE',
      });
    }

    const dataServiceCall = {
      preferredTaxRate: '0',
      price: data.price,
      enable: 'true',
      unlimited: 'true',
      serviceVersion: data.currentVersion,
      description: data.description,
      status: 'pending',
      scProvider: data.scProvider,
      ...metaDataObj,
    };

    if (id) {
      dataServiceCall.productId = id;
      if (increaseVersion) {
        dataServiceCall.increaseVersion = true;
      }
    }

    const dataApi = {
      dataServiceCall,
      serviceSetId: data.serviceSet.map((val) => val.id),
    };

    setLoading(true);

    async function addServiceCall(params) {
      let result;

      try {
        if (id) {
          result = await serviceCallEditApi(params);
        } else {
          result = await serviceCallAddApi(params);
        }


        setOpenSnack(true);
        setLoading(false);

        createToast('موفق', 'تعریف سرویس با موفقیت افزوده شد.', 'success');

        setOpenSnack(true);
        navigate('/WebService');
      } catch (error) {
        setOpenSnack(true);
        setLoading(false);
      }
    }

    addServiceCall(dataApi);
  };

  useEffect(() => {
    (async () => {
      try {
        if (id) {
          setLoadingPage(true);
          const edit = new generateEdit(id);
          const data = await edit.getData();
          if (data?.scInputParams) {
            setDataBody(data.scInputParams);
          }

          /*
            1- تغییر متد 
            2- روش محاسبه
            3- نوع دسترسی
            4- قیمت
            5- آدرس وب سرویس 
          */
          setOriginalData({
            currentVersion: data.serviceVersion,
            checkVersion: {
              scHttpVerb: data.scHttpVerb,
              scUrl: data.scUrl,
              price: data.price,
              scPriceCalculationType: data.scPriceCalculationType,
              scAutoApprove: !!data.scAutoApprove,
            },
          });

          reset({ ...data });
        }
      } catch (error) {
        setOpenSnack(true);
      }
    })();
  }, [id]);

  const breadcrumbsCreat = [
    {
      title: 'میز کار سرویس‌دهنده',
      link: null,
    },
    {
      title: 'تعریف سرویس جدید',
    },
  ];
  const breadcrumbsEdit = [
    {
      title: 'میز کار سرویس‌دهنده',
      link: null,
    },
    {
      title: 'سرویس‌های من',
      link: '/WebService',
    },
    {
      title: 'ویرایش وب سرویس',
    },
  ];
const getKeyBreadCrumbsWithUrl = () => {

  return id
    ? constBreadCrumbsTitle.WEBSERVICE_EDIT
    : constBreadCrumbsTitle.WEBSERVICE_ADD;
};

  return (
    <PageContainer
      title={id ? 'ویرایش وب سرویس' : 'تعریف وب سرویس'}
      breadcrumbs={getKeyBreadCrumbsWithUrl()}
    >
      {(actionsList['newWebServiceDefinePage'] || actionsList['editMyWebServiceListBtn']) && (
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
            <StepperKeeper
              stepsToHideNext={'false'}
              onChangeTab={onChangeTab}
              titles={[
                { label: 'اطلاعات پایه' },
                { label: 'پارامترهای body', liner: 'dotted' },
                { label: 'تنظیمات پیشرفته' },
              ]}
              panels={[
                <BaseInfo
                  selected={selected}
                  classes={classes}
                />,
                <BodyParameters bodyChange={bodyChange} dataBody={dataBody} />,
                <Advanced selected={selected} selectChange={selectChange} classes={classes} />,
              ]}
              formAction={
                <Grid container item xs={12} justifyContent="flex-end">
                  <div className={classes.containButton}>
                    {tabIndex !== 0 && (
                      <ButtonLoading
                        type="submit"
                        variant="contained"
                        color="primary"
                        loading={loading}
                        name="ساخت وب سرویس"
                        disabled={tabIndex === 0}
                      />
                    )}
                      <Button variant="contained" onClick={() => navigate('/WebService')}>
                        انصراف
                      </Button>
                  </div>
                </Grid>
              }
            />
          </form>
        </FormProvider>
      )}
    </PageContainer>
  );
};

export default DefineWebService2;
